export default function fallbacks() {
    return {
        menu(name) {
            if (name === 'main') {
                return {
                    menu_name: 'main',
                    menu_items: [
                        {
                            link: { title: 'Horaires et trajets', uri: '#', external: false },
                            langcode: 'fr',
                            icon_svg: 'horaires-trajets',
                            display_menu: 'all',
                            children: [
                                {
                                    link: {
                                        title: 'Horaire des bus',
                                        uri: '/horaires-et-trajets/horaires-des-bus',
                                        external: false,
                                    },
                                    langcode: 'fr',
                                    icon_svg: null,
                                    display_menu: 'all',
                                },
                            ],
                        },
                    ],
                };
            }
            return null;
        },
    };
}
